import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69db395e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header-nav-links" }
const _hoisted_2 = { class: "app-header-nav-links__text" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import { accountService } from '@exchange/libs/account/service/src';

interface HeaderLink {
  id: TradeNavLink;
  withLozenge: boolean;
  selected: boolean;
  text: string;
  onClick: () => void;
}


export enum TradeNavLink {
  spot = 'spot',
  instantTrade = 'portfolio',
  futures = 'futures',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderNavLinks',
  emits: ["link-clicked"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n({ useScope: 'global' });
const route = useRoute();
const { userIsBroker } = accountService;

const links = computed<Array<HeaderLink>>(() => [
  ...(userIsBroker.value
    ? []
    : [
        {
          id: TradeNavLink.instantTrade,
          withLozenge: false,
          selected: route.name === 'portfolio',
          text: 'Swap',
          onClick: () => emit('link-clicked', TradeNavLink.instantTrade),
        },
      ]),
  {
    id: TradeNavLink.spot,
    withLozenge: true,
    selected: ['spot', 'futures'].includes(route.name as string),
    text: t('modules.header.navButtons.spot'),
    onClick: () => emit('link-clicked', TradeNavLink.spot),
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
      return (_openBlock(), _createBlock(_component_x_button, {
        key: link.id,
        class: "app-header-nav-links__item",
        variant: "nav",
        size: "lg",
        "active-nav": link.selected,
        onClick: link.onClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(link.text), 1)
        ]),
        _: 2
      }, 1032, ["active-nav", "onClick"]))
    }), 128))
  ]))
}
}

})